<template>
  <div class="routine-rule">
      <div class="min-width-sm" :style="{ width: '10%'}">
          <input :value="priority" :style="{ width: '65px'}" @input="(e) => handleRuleinput('priority',e)" type="number"/>
      </div>
       <div :style="{ width: '30%'}">
             <div class="select">
                  <select class="select__input select__input--sm" value="bank" @change="(e) =>  handleRuleinput('bank_code',e)">
                        <option v-for="bank in bankList" :value="bank.code" :key="bank.code" :selected="bankCode ? bank.code == bankCode : bank.code === '060001'">{{ bank.bank }}</option>
                  </select>
              </div>
      </div>
      <div class="min-width-md" :style="{ width: '15%'}">
          <input v-model="state.prefix" :style="{ width: '127px'}" @input="(e) => handleRuleinput('bank_prefix', e)" />
      </div>
       <div class="min-width-md percentage" :style="{ width: '15%'}">
          <div>
              <input v-model="state.preExisting" :style="{ width: '103px'}" @input="(e) => handleRuleinput('percent_of_merchants', e)" />
              <p>%</p>
          </div>
      </div>
       
      <div class="routine-rule__incoming" :style="{ width: '30%', display: 'flex'}">
        <div :style="{ display: 'flex'}">
                 <input :value="incomingMin" :style="{ width: '95px'}" @input="(e) => handleRuleinput('minimum_incoming', e)" type="number"/>
          <div class="center">
              <svg width="31" height="8" viewBox="0 0 31 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M30.3536 4.35355C30.5488 4.15829 30.5488 3.84171 30.3536 3.64645L27.1716 0.464466C26.9763 0.269204 26.6597 0.269204 26.4645 0.464466C26.2692 0.659728 26.2692 0.976311 26.4645 1.17157L29.2929 4L26.4645 6.82843C26.2692 7.02369 26.2692 7.34027 26.4645 7.53553C26.6597 7.7308 26.9763 7.7308 27.1716 7.53553L30.3536 4.35355ZM0 4.5H30V3.5H0L0 4.5Z" fill="#D3D2D5"/>
              </svg>
          </div>
            <div :class="incomingMax === 'infinity' ? 'infinity' : ''">
                <input :value="incomingMax" :style="{ width: '95px'}" @input="(e) => handleRuleinput('maximum_incoming', e)" type="number"  >
                <svg v-if="incomingMax === 'infinity'" width="20" height="9" viewBox="0 0 20 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.7142 0C13.4821 0 11.0714 2.16215 9.99998 3.245C8.92855 2.16215 6.51784 0 4.28571 0C1.60216 0 0 1.60216 0 4.28571C0 6.96926 1.60216 8.57142 4.28571 8.57142C6.51784 8.57142 8.92855 6.40927 9.99998 5.32642C11.0714 6.40927 13.4821 8.57142 15.7142 8.57142C18.3978 8.57142 20 6.96926 20 4.28571C20 1.60216 18.3978 0 15.7142 0ZM4.28567 7.14286C2.38995 7.14286 1.42851 6.18142 1.42851 4.28571C1.42851 2.38999 2.38995 1.42856 4.28567 1.42856C5.85711 1.42856 7.9428 3.19926 9.01996 4.28571C7.94497 5.37359 5.86351 7.14286 4.28567 7.14286ZM15.7142 7.14286C14.1428 7.14286 12.0571 5.37216 10.98 4.28571C12.0514 3.19859 14.1364 1.42856 15.7142 1.42856C17.61 1.42856 18.5714 2.38999 18.5714 4.28571C18.5714 6.18142 17.61 7.14286 15.7142 7.14286Z" fill="black"/>
                </svg>
            </div>
            </div>
            <div>
                <Button v-if="!showDelete" buttonName="Add Rule" :onClick="() => handleRuleDelete(id)" classes="grey"  />
                <Button v-if="showDelete" buttonName="Delete" :onClick="() => handleRuleDelete(id)" classes="grey"  />
            </div>
      </div>

  </div>
</template>
<script>
import Button from "@/components/button.vue"
import { reactive, onBeforeMount, computed, watch } from '@vue/composition-api'

export default {
    name: 'RoutineRule',
    components: {
        Button
    },
    props: {
        priority: [Number, String],
        bank: String,
        prefix: String,
        preExisting: String,
        incomingMax: [Number, String],
        incomingMin: [Number, String],
        showDelete: Boolean,
        id: String,
        handleRuleDelete: Function,
        onRuleChange: Function,
        bankCode: String,
        reset: Boolean,
        handleResetToggle: Function
    },
  setup(props, { root }) {
    const store = root.$store;
        const state = reactive({
            preExisting: props.preExisting,
            prefix: props.prefix
        })


       const bankList = computed(() => store.getters.getBankList);


        watch(() => props.reset, (value) => {
            if(props.reset) {
                state.prefix = '******'
                state.preExisting = '%'

                props.handleResetToggle()
            }
        })
        
        const handleRuleinput = (field, { target: { value } }) => {
            switch (field) {
                case 'percent_of_merchants': {
                        state.preExisting =  value 
                        props.onRuleChange({ id: props.id, field, value })
                        return;
                    }
                case 'bank_prefix': {
                        const raw = value.split('******').length == 1 ? '' : value.split('******')[0];
                        state.prefix = raw + '******';
                        props.onRuleChange({ id: props.id, field, value: raw })
                        return;  
                    }          
                default:
                    props.onRuleChange({ id: props.id, field, value })
                    break;
            }
      
        }

        return {
            handleRuleinput,
            bankList,
            state,
        }
    }
}
</script>
<style lang="scss">
.routine-rule {
    display: flex;
    padding: 19px 0;
    border-top: 1px solid #EBF0F4;

    input {
        background: #FFFFFF;
        border: 1px solid #CBD2D9;
        box-sizing: border-box;
        border-radius: 2px;
        padding: 14px 18px;
        text-align: center;

        &:focus {
            outline: none
        }
    }

      /* Chrome, Safari, Edge, Opera */
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }
        /* Firefox */
        input[type="number"] {
            -moz-appearance: textfield;
        }
        input::-ms-reveal,
        input::-ms-clear {
            display: none;
        }

    .button-comp {
        height: 100%;

        .btn {
            height: 100%;
            width: 100px;
        }
    }

    &__incoming {
        display: flex;
        justify-content: space-between;
        align-items: center;

        svg {
            margin: 0 20px;
        }
    }

    .infinity {
        position: relative;

        svg {
            position: absolute;
            left: 40%;
            top: 40%;
        }
    }

    .center {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .select {
        max-width: 350px;
        height: 100%;

        select {
            height: 100%;
            border-radius: 2px;
            color: #000;
        }
    }

    .percentage {
        display: flex;
        align-items: center;
        position: relative;

        > div {
            display: flex;
            align-items: center;
            position: relative;
        }

        p {
            position: absolute;
            left: 80%; 
        }
    }
}
</style>